/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Menu.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ButtonTab from 'DesignSystem/ButtonTab/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  marginTop: 40,
marginLeft: 30,
marginRight: 16,
width: 150})

export default function Menu({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isNotNewUserAndIsMemberGroupAdmin,
isActingAsSupport,
isNewUser,
isProvider,
isNotNewUserAndIsProviderAdminOrIsSupport,
viewPath= "/App/MyAccount/Content/Profile/Menu"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<div
 data-testid="Menu.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
 className={`views-block ${styles.Vertical}`}
>
<ButtonTab
 data-testid="Menu.ButtonTab"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/UserProfile")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/UserProfile")}
 text="User Profile"
/>
{
isNotNewUserAndIsMemberGroupAdmin ? 
<ButtonTab
 data-testid="Menu.ButtonTab:1"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Employees")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Employees")}
 text="Employees"
 marginTop={10}
/>
 : null
}
{
isActingAsSupport ? 
<ButtonTab
 data-testid="Menu.ButtonTab:2"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Individuals")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Individuals")}
 text="Individuals"
 marginTop={10}
/>
 : null
}
{
!isNewUser ? 
<ButtonTab
 data-testid="Menu.ButtonTab:3"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Admins")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Admins")}
 text="Admins"
 marginTop={10}
/>
 : null
}
{
isProvider ? 
<ButtonTab
 data-testid="Menu.ButtonTab:4"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyProfessionals")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyProfessionals")}
 text="Professionals"
 marginTop={10}
/>
 : null
}
{
isProvider ? 
<ButtonTab
 data-testid="Menu.ButtonTab:5"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyLocations")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyLocations")}
 text="Locations"
 marginTop={10}
/>
 : null
}
<ButtonTab
 data-testid="Menu.ButtonTab:6"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/MyCompanies")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/MyCompanies")}
 text="Companies"
 marginTop={10}
/>
{
isNotNewUserAndIsProviderAdminOrIsSupport ? 
<ButtonTab
 data-testid="Menu.ButtonTab:7"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Utilization")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Utilization")}
 text="Utilization"
 marginTop={10}
/>
 : null
}
{
isActingAsSupport ? 
<ButtonTab
 data-testid="Menu.ButtonTab:8"
 data-view-path="/App/MyAccount/Content/Profile/Menu"
viewPath={`${viewPath}/ButtonTab`}
 onClick={() => setFlowTo("/App/MyAccount/Content/Profile/Content/Affiliates")}
 isSelected={flow.has("/App/MyAccount/Content/Profile/Content/Affiliates")}
 text="Affiliates"
 marginTop={10}
/>
 : null
}
</div>
{children}
</React.Fragment>)
}